import React from "react";
import { useTable, useGlobalFilter, usePagination } from "react-table";

export const Upload = ({ columns, data }) => {
    const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        usePagination
    );

    return (
        <div className="customTable">
            {/* <div className="customTable__header">
				<div className="customTable__left">
					<div className="customTable__showingRecords">
						<label>Show Records:</label>
						<select className="form-control" value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
							{[10, 25, 50, 100].map((pageSize) => (
								<option key={pageSize} value={pageSize}>
									{pageSize}
								</option>
							))}
						</select>
					</div>
				</div>
				<div className="customTable__right">
					<CustomFilter filter={globalFilter} setFilter={setGlobalFilter} />
				</div>
            </div> */}

            <div className="customTable__body">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered" {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup) => {
                                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                                return (
                                    <tr key={key} {...headerGroupProps}>
                                        {headerGroup.headers.map((column) => {
                                            const { key, ...headerProps } = column.getHeaderProps();
                                            return <th key={key} {...headerProps}>{column.render("Header")}</th>;
                                        })}
                                    </tr>
                                );
                            })}
                        </thead>
                        {Array.isArray(data) ? (
                            <tbody {...getTableBodyProps()}>
                                {page.map((row) => {
                                    prepareRow(row);
                                    const { key, ...rowProps } = row.getRowProps();
                                    return (
                                        <tr key={key} {...rowProps}>
                                            {row.cells.map((cell) => {
                                                const { key, ...cellProps } = cell.getCellProps();
                                                return <td key={key} {...cellProps}>{cell.render("Cell")}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={4}>
                                        <p style={{ textAlign: "center", margin: 0 }}>No data found</p>
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </div>
    );
};
